const UiRadioGroupPropsOption = {
  modelValue: { type: String, required: true },
  name: { type: String }
};
const UiRadioGroupEmits = {
  "update:modelValue": (value) => true,
  "change": () => true
};
const UiRadioGroupInjectionKey = Symbol("UiRadioGroupInjectionKey");

export { UiRadioGroupEmits, UiRadioGroupInjectionKey, UiRadioGroupPropsOption };
//# sourceMappingURL=index.mjs.map
